import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67d260bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "amendment-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_ctx.isAmendment === true)
    ? (_openBlock(), _createBlock(_component_BaseSection, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", null, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("amendment.title")), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("amendment.description")), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}